export interface SlotOptions {
  [key: string]: number;
}

interface WeekDay {
  label: string;
  value: WeekdayTimeslot;
}

type WeekdayTimeslot =
  | "mondayTimeslots"
  | "tuesdayTimeslots"
  | "wednesdayTimeslots"
  | "thursdayTimeslots"
  | "fridayTimeslots"
  | "saturdayTimeslots"
  | "sundayTimeslots";

export function slotOptions(): SlotOptions {
  let r: SlotOptions = {};
  let index = 1;
  for (let h = 0; h < 12; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hour = h === 0 ? "12" : h < 10 ? "0" + h : h;
      r[`${hour}:${m < 10 ? "0" + m : m}am`] = index;
      r[`${hour}:${m < 10 ? "0" + m : m}pm`] = index + 48;
      index += 1;
    }
  }
  return r;
}

export const SLOT_OPTIONS: SlotOptions = slotOptions();

export const weekDays: WeekDay[] = [
  {
    label: "Monday",
    value: "mondayTimeslots",
  },
  {
    label: "Tuesday",
    value: "tuesdayTimeslots",
  },
  {
    label: "Wednesday",
    value: "wednesdayTimeslots",
  },
  {
    label: "Thursday",
    value: "thursdayTimeslots",
  },
  {
    label: "Friday",
    value: "fridayTimeslots",
  },
  {
    label: "Saturday",
    value: "saturdayTimeslots",
  },
  {
    label: "Sunday",
    value: "sundayTimeslots",
  },
];
